<div class="flex flex-col m-6">

    <!-- HEADER -->
    <div class="mb-6">
        <h3 class="text-xl font-semibold text-gray-800">
            Edit User Role
        </h3>
        <p class="text-sm text-gray-500 mt-1">
            Update the role for {{ user?.name || 'this user' }}.
        </p>
    </div>

    <!-- FORM -->
    <form [formGroup]="form" (ngSubmit)="submit()" class="space-y-5">

        <!-- ROLE SELECT -->
        <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
                Role <span class="text-red-500">*</span>
            </label>

            <select formControlName="role" class="w-full rounded-lg border border-gray-300 px-4 py-2.5 text-sm
               focus:ring-2 focus:ring-primary focus:border-primary outline-none transition bg-white">
               <option value="user">User</option>
               <option value="mechanic">Mechanic</option>
               <option value="admin">Admin</option>
            </select>

            <p *ngIf="form.get('role')?.touched && form.get('role')?.invalid" class="text-xs text-red-500 mt-1">
                Role is required.
            </p>
        </div>

        <!-- FOOTER -->
        <div class="flex justify-end gap-3 pt-4 border-t">
            <app-button size="sm" variant="outline" (btnClick)="cancel.emit()">
                Close
            </app-button>
            <app-button size="sm" (btnClick)="submit()" [disabled]="form.invalid">Update Role</app-button>
        </div>

    </form>

</div>